module.exports = __webpack_public_path__ + "img/map_1791551951423_62200.40e43c30.jpg";